export const darkModeKey = 'darkMode'

export const styleKey = 'style'
